import * as React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'
import { Url } from 'url'
import { useFallbackImageInSSR } from 'utils'

const defaultImageSrc = {
  channel: '/static/images/channel/enterprise.png',
  user: '/static/images/channel/user-profile.png',
}

type AvatarProps = {
  type?: 'channel' | 'user'
  src?: string | null
  href?: Url | string
  size?: number
  className?: string
  enableNextImage?: boolean
}

const Avatar: React.FC<AvatarProps> = ({
  type = 'user',
  src,
  href = '',
  size = 36,
  enableNextImage = false,
  className,
}) => {
  const defaultSrc = defaultImageSrc[type]
  const fallbackImageProps = useFallbackImageInSSR(defaultSrc)

  return (
    <StyledWrapper
      className={className}
      data-type={type}
      customCss={css`
        width: ${size}px;
        height: ${size}px;
        a {
          cursor: ${href ? `pointer` : `default`};
        }
      `}
    >
      <Link href={href} scroll={!!href}>
        <a>
          {enableNextImage ? (
            <Image
              src={src || defaultSrc}
              alt=""
              width={size}
              height={size}
              {...fallbackImageProps}
            />
          ) : (
            <img src={src || defaultSrc} alt="avatar" {...fallbackImageProps} />
          )}
        </a>
      </Link>
    </StyledWrapper>
  )
}

export default Avatar

type StyledWrapperType = {
  customCss?: FlattenSimpleInterpolation
}

const StyledWrapper = styled.div<StyledWrapperType>`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  a {
    width: 100%;
    height: 100%;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  &[data-type='channel'] {
    border-radius: 5px;
    border: 1px solid #dddddd;
  }
  ${({ customCss }) => customCss}
`
